import {
  Box,
  Grid,
  Button,
  TextField,
  Typography,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Dialog,
  TablePagination,
} from "@mui/material";
import { CancelPresentation as CancelPresentationIcon } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import { useDialogueState } from "../../../../Context/DialogueProvider";
import {
  getRoomMaster,
  manageMstPropFloorConfig,
  manageMstPropRoomConfig,
} from "../../../../Api/RoomMst/Api";
import { toast } from "react-toastify";

const columns = [
  { id: "PropName", label: "Property", minWidth: 90 },
  { id: "WingName", label: "Wing", minWidth: 50 },
  { id: "FloorName", label: "Floor", minWidth: 50 },
  { id: "RoomNo", label: "Room No.", minWidth: 50 },
];

export default function GenarateBeds({
  PropId,
  getAllRoomBedMstDashBoardDataTable,
  UserId,
}) {
  const { dialogueState, handleDialogueToggle } = useDialogueState();

  const [searchTerms, setSearchTerms] = useState({});
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(0);
  const [changedRow, setChangedRow] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(15);

  const getRoomMasterData = async () => {
    const response = await getRoomMaster({
      start: 0,
      PageSize: 1,
      SearchText: PropId,
    });
    if (response instanceof Error) {
      return toast.error(response.message, { autoClose: 1000 });
    }
    const { data: { Status, Data } } = response;

    if (Status === 0) {
      setRows(Data.sort((a, b) => a.RoomId - b.RoomId));
    } else {
      setRows([]);
    }
  };

  useEffect(() => {
    if (PropId) {
      getRoomMasterData();
    }
  }, [PropId]);

  // Handle the "Update Beds" button click
  const handleUpdateBeds = async () => {
    if (
      filteredRows
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .every((row) => typeof row.TotalBeds === "number") === false
    ) {
      return toast.info("Fill all the empty details.");
    }
    if (changedRow.length < 1) {
      return toast.info("There is nothing to  update.");
    }

    let payload = {
      PropFloorConfig: changedRow.map(
        ({ PropId, WingId, FloorId, RoomNo, RoomNum = 0, TotalBeds }) => ({
          PropId,
          WingId,
          FloorId,
          RoomNo,
          RoomNum,
          TotalBeds,
        })
      ),
    };

    let json = JSON.stringify(payload);

    json = json.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
    json = '"' + json + '"';

    const response = await manageMstPropRoomConfig(json);

    if (response instanceof Error) {
      return toast.error("Error: could not update room config");
    }
    const { data: { Status, responseStatusCode, Message }, } = response;

    if (Status === 0 && responseStatusCode === 1 && Message) {
      setChangedRow([]);
      setSearchTerms(
        () =>
          columns.reduce((acc, curr) => {
            acc[curr.id] = "";
            return acc;
          }),
        {}
      );
      getAllRoomBedMstDashBoardDataTable(UserId);
      toast.success(Message, {
        autoClose: 1000,
        onClose: () => handleDialogueToggle(),
      });
    }
  };

  const handleGenerateBeds = async () => {
    const response = await manageMstPropFloorConfig({ PropId });

    if (response instanceof Error) {
      return toast.error("Error: could not generate beds");
    }

    const { data: { Status, responseStatusCode }, } = response;

    if (Status === 0 && responseStatusCode === 1) {
      await getAllRoomBedMstDashBoardDataTable(UserId);
      toast.success("Beds Generated Successfully", {
        autoClose: 1000,
        onClose: () => handleDialogueToggle(),
      });
    }
  };

  const handleSearchChange = (columnId, value) => {
    setSearchTerms((prev) => ({ ...prev, [columnId]: value }));
    setPage(0);
  };

  const handleBedsChange = (e) => {
    const newValue = e.target.value;
    const id = e.target.name;

    const row = rows.find((r) => r.RoomId == id);
    const restRows = rows.filter((r) => r.RoomId != id);

    if (row) {
      let parsedValue = newValue;

      // Check if the value is "1"
      if (parsedValue === "1") {
        toast.info("Please enter a value greater than 1.", {
          autoClose: 2000,
        });
        return;
      }

      if (parsedValue) {
        if (!isNaN(newValue)) {
          parsedValue = parseInt(parsedValue, 10);
        }

        if (isNaN(newValue)) {
          parsedValue = row.TotalBeds;
        }
      }

      if (row) {
        row.TotalBeds = parsedValue;
      }

      restRows.push(row);

      setRows(restRows.sort((a, b) => a.RoomId - b.RoomId));
      setChangedRow(handleChangedRow(row));
    }
  };

  function handleChangedRow(row) {
    const index = changedRow.findIndex((r) => r.Roomid === row.RoomId);

    if (index !== -1) {
      changedRow[index] = row;
      return changedRow;
    }

    const restRows = changedRow.filter((r) => r.RoomId !== row.RoomId);

    return [row, ...restRows];
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const filteredRows = React.useMemo(() => {
    return rows.filter((row) => {
      return Object.entries(searchTerms).every(([columnId, term]) => {
        if (!term) return true;
        const value = row[columnId];
        if (typeof value === "string") {
          return value.toLowerCase().includes(term.toLowerCase());
        } else if (typeof value === "number") {
          return value.toString().includes(term);
        } else if (typeof value === "object") {
          return false;
        }
        return true;
      });
    });
  }, [searchTerms, rows]);

  return (
    // <Grid item xs={12} md={2} lg={6}>
    <Grid item>
      <Button
        variant="contained"
        color="primary"
        sx={{
          background: "#635bff",
          color: "white",
          borderRadius: "50px",
          padding: "6px 15px",
          boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.2)",
          "&:hover": {
            background: "#524ccc"
          }
        }}
        size="small"
        onClick={() => handleDialogueToggle(true, null)}
      >
        Bed Configuration
      </Button>

      <Dialog
        open={dialogueState.isOpen}
        onClose={() => handleDialogueToggle(false, null)}
        maxWidth="auto"
      >
        <DialogTitle>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="title" fontWeight="bold">
              Bed Configuration
            </Typography>

            <CancelPresentationIcon
              variant="contained"
              size="small"
              colour="primary"
              onClick={() => handleDialogueToggle(false, null)}
            />
          </Box>
        </DialogTitle>
        <DialogContent sx={{ paddingBlock: "4px", paddingInline: "24px" }}>
          <Paper
            sx={{
              maxWidth: "100%",
              overflow: "hidden",
              margin: "4px 0px 0px 0px",
              border: "1px solid lightgray",
            }}
          >
            <TableContainer sx={{ maxHeight: 350 }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow
                    sx={{
                      "& > th": {
                        padding: "2px  10px 2px  10px",
                      },
                    }}
                  >
                    {columns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                      >
                        <Typography variant="subtitle1" fontWeight="bold">
                          {column.label}
                        </Typography>
                        <TextField
                          size="small"
                          variant="outlined"
                          placeholder={`Search ${column.label}`}
                          value={searchTerms[column.id]}
                          onChange={(e) =>
                            handleSearchChange(column.id, e.target.value)
                          }
                          sx={{
                            mt: 1,
                            margin: "0px",
                            "& .MuiOutlinedInput-input": {
                              padding: "2px 2px",
                            },
                          }}
                        />
                      </TableCell>
                    ))}
                    <TableCell style={{ minWidth: 50 }}>
                      <Typography variant="subtitle1" fontWeight="bold">
                        Total Beds
                      </Typography>
                      <TextField
                        size="small"
                        variant="outlined"
                        placeholder={`Search Total Beds`}
                        onChange={(e) =>
                          handleSearchChange("TotalBeds", e.target.value)
                        }
                        sx={{
                          mt: 1,
                          margin: "0px",
                          "& .MuiOutlinedInput-input": {
                            padding: "2px 6px",
                          },
                        }}
                      />
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredRows
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, idx) => {
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={idx}
                          style={{ cursor: "pointer" }}
                          sx={{
                            "& > td": {
                              padding: "2px  14px 2px  19px",
                            },
                          }}
                        >
                          {columns.map((column) => {
                            const value = row[column.id];
                            return (
                              <TableCell key={column.id} align={column.align}>
                                {value}
                              </TableCell>
                            );
                          })}
                          <TableCell>
                            <TextField
                              variant="outlined"
                              id={row.RoomId}
                              name={row.RoomId}
                              size="small"
                              value={row.TotalBeds}
                              onChange={handleBedsChange}
                              sx={{
                                "& .MuiOutlinedInput-input": {
                                  padding: "2px 6px",
                                },
                              }}
                            />
                            {/* {row.TotalBeds} */}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 15, 50, 100]}
              component="div"
              count={filteredRows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </DialogContent>
        <DialogActions sx={{ marginRight: "15px" }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleGenerateBeds}
            sx={{
              //background: "linear-gradient(45deg, #635bff, #1E90FF)",
              background: "#635bff",
              color: "white",
              borderRadius: "50px",
              padding: "8px 20px",
              boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.3)",
              transition: "background 0.3s ease",
            }}
          >
            Generate Beds
          </Button>
          <Button variant="contained"
            color="primary"
            onClick={handleUpdateBeds}
            sx={{
              //background: "linear-gradient(45deg, #635bff, #1E90FF)",
              background: "#635bff",
              color: "white",
              borderRadius: "50px",
              padding: "8px 20px",
              boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.3)",
              transition: "background 0.3s ease",
            }}>
            Update Room Bed
          </Button>

        </DialogActions>
      </Dialog>
    </Grid>
  );
}
